import * as yup from 'yup';
import { emailField, INVITED_NAME_MAX, optionalText, TranslateFn } from '../../../library/validationRules';

export const createInviteTherapistSchema = (translate: TranslateFn) => yup.object({
    // Deliberately without the allowAdminHandle flag the login form passes: that lets the
    // literal string "admin" through, which is a sign-in handle rather than a mailbox, and
    // an invitation that cannot be delivered is worse than useless.
    emailAddress: emailField(translate),
    // optionalText rather than requiredText: the field may be blank -- the invitee fills
    // in their own name -- but the form always supplies a string, so the inferred type
    // matches InviteTherapistFormValues instead of widening to string | undefined.
    firstName: optionalText(translate, INVITED_NAME_MAX),
    lastName: optionalText(translate, INVITED_NAME_MAX),
});
